module.exports = __webpack_public_path__ + "static/img/6.08a667a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/solution/6.png
// module id = CsU4
// module chunks = 3